<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <h3>Zie hoe Roosterplatform werkt</h3>
            <h1>Meld u aan voor ons gratis webinar</h1>
            <p>
              In ons webinar ziet u hoe Roosterplatform volledig geautomatiseerd
              een optimale behandelagenda plant.
            </p>
            <img
              src="../assets/img/webinar.jpg"
              alt="Roosterplatform webinar"
            >
          </div>
          <div class="col-6">
            <iframe
              class="zoho-form"
              width="610px"
              height="350px"
              src="https://crm.zoho.com/crm/WebFormServeServlet?rid=61b8239ee9f29d0984a26a454f65afbcc15367c476a2df922f5e630b5adabf46gid326a4cd1ddea7cc4c1d6d3044679fca61a9a029aafed99a30972d287f6bb6add"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="section primary extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <span>Ons webinar</span>
          <h2>Wat u kunt verwachten?</h2>
        </div>
        <ol>
          <li>Wat plant Roosterplatform?</li>
          <li>Hoe weet Roosterplatform op welke manier gepland moet worden?</li>
          <li>Hoe helpt Roosreplatfrom bij het oplossen van knelpunten?</li>
          <li>
            Hoe ondersteunt Roosterplatform bij sturen op continue kwaliteit van
            de planning?
          </li>
          <li>
            Hoe zorgt Roosterplatform ervoor dat altijd de juiste afspraken in
            het ECD/EPD staan?
          </li>
        </ol>
        <p>
          En uiteraard kunt u vragen stellen. Het webinar begint om 15:00 en
          duurt tot 17:30.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Webinar",

  mounted() {},
  methods: {},
  metaInfo() {
    return {
      title: "Roosterplatform - Webinar",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
img {
  border-radius: $border-radius;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
